import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class TransferIncoming extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Transfer Request');
    public static getDescription:Function = () => Locale.gettext('A user wishes to transfer ownership of a site to you');
    
    public static supportedRoutes:string[] = [ "push", "email" ];
}